import { render, staticRenderFns } from "./ActorGallery.vue?vue&type=template&id=8bb4f73c&scoped=true&"
import script from "./ActorGallery.vue?vue&type=script&lang=js&"
export * from "./ActorGallery.vue?vue&type=script&lang=js&"
import style0 from "./ActorGallery.vue?vue&type=style&index=0&id=8bb4f73c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb4f73c",
  null
  
)

export default component.exports